import { createSubscription, getSubscription } from '../thunks/organization-subscription';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const organizationSubscriptionReducers = (builder) => {
  builder
    .addCase(getSubscription.fulfilled, (state, action) => handleFulfilled(state, 'subscription', action))
    .addCase(getSubscription.pending, (state) => handlePending(state, 'subscription'))
    .addCase(getSubscription.rejected, (state) => handleRejected(state, 'subscription'));

  builder
    .addCase(createSubscription.fulfilled, (state, action) => handleFulfilled(state, 'subscriptionStripe', action))
    .addCase(createSubscription.pending, (state) => handlePending(state, 'subscriptionStripe'))
    .addCase(createSubscription.rejected, (state) => handleRejected(state, 'subscriptionStripe'));
};
